<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [header]="headerKey | transloco"
  styleClass="ig-report-dialog"
  [style]="{ width: 'min(400px, calc(100vw - 32px))' }"
>
  <label
    style="display:block;margin-bottom:6px;color:#e0e0e0;font-family:'Saira',sans-serif;font-size:.85rem;font-weight:500;"
  >
    {{ "socialFeed.reportReason" | transloco }} <span style="color:#AC281C;">*</span>
  </label>
  <p-dropdown
    [options]="reasonKeys"
    [(ngModel)]="reasonKey"
    [placeholder]="'socialFeed.reportReasonPlaceholder' | transloco"
    appendTo="body"
    [style]="{ width: '100%' }"
  >
    <ng-template pTemplate="selectedItem" let-key>
      <span>{{ ('socialFeed.reportReasons.' + key) | transloco }}</span>
    </ng-template>
    <ng-template pTemplate="item" let-key>
      <span>{{ ('socialFeed.reportReasons.' + key) | transloco }}</span>
    </ng-template>
  </p-dropdown>

  <label
    style="display:block;margin:12px 0 6px;color:#e0e0e0;font-family:'Saira',sans-serif;font-size:.85rem;font-weight:500;"
  >
    {{ "socialFeed.reportDetail" | transloco }}
  </label>
  <textarea
    rows="3"
    maxlength="500"
    [(ngModel)]="detail"
    [placeholder]="'socialFeed.reportDetailPlaceholder' | transloco"
    style="width:100%;background:#303136;border:1px solid #474A52;border-radius:6px;color:#e0e0e0;font-family:'Saira',sans-serif;font-size:.9rem;padding:10px 12px;resize:vertical;outline:none;box-sizing:border-box;"
  ></textarea>
  <button
    style="margin-top:12px;width:100%;display:flex;align-items:center;justify-content:center;gap:8px;background:#AC281C;color:#fff;border:none;border-radius:6px;padding:12px;font-weight:600;font-size:.9rem;font-family:'Saira',sans-serif;cursor:pointer;"
    [disabled]="submitting || !reasonKey"
    (click)="submit()"
  >
    <i *ngIf="submitting" class="pi pi-spin pi-spinner"></i>
    {{ "socialFeed.send" | transloco }}
  </button>
</p-dialog>
